module.exports = __webpack_public_path__ + "media/images/pages/fig_dataFamily_01-29b965825764a562ce231b1437377095.png";